import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SaveButton } from '~/components/button';
import { FormLayout } from '~/components/settings';
import { usePlaylist } from '../context';
import { useSettingsForm } from '../lib/settings';
import { ActionBar } from '../lib/styles';

export const SettingsForm = () => {
  const { t } = useTranslation();
  const { playlist } = usePlaylist();
  const { generalSettings, formik } = useSettingsForm();

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <ActionBar>
        <SaveButton
          disabled={
            !playlist.canUpdate.value || !formik.isValid || formik.isSubmitting || !formik.dirty
          }
          type="submit"
        >
          {t('common.actions.save')}
        </SaveButton>
      </ActionBar>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
        <FormLayout formHeading={t('common.labels.general')} formData={generalSettings} />
      </Box>
    </form>
  );
};
